import styles from "../bussiness.module.css";
import BoxScore from "./BoxScore";
import DeleteScore from "./modal/DeleteScore";
import AddScore from "./modal/AddScore";
import EditScore from "./modal/EditScore";
import { useState } from "react";
import { AiFillLeftCircle } from "react-icons/ai";
import FilterScore from "./modal/FilterScore";

const Score = () => {
  const [selectedItem, setSelectedItem] = useState({});
  const [customers, setCustomers] = useState([
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 0,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 1,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 2,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 3,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 4,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      submitTime: new Date().getDate(),
      date: new Date().getDate(),
      type: "",
      price: 7,
      id: 5,
    },
  ]);
  return (
    <div className=" w-100 mt-2 ">
      <div className={`container ${styles.containShadow} `}>
        <div className="container w-100">
          {customers ? (
            customers.map((item, index) => {
              return (
                <div>
                  <BoxScore
                    item={item}
                    key={item.id}
                    customers={customers}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    setCustomers={setCustomers}
                  />
                </div>
              );
            })
          ) : (
            <p>Loading...</p>
          )}

          <div className="d-flex justify-content-center mt-4">
            <AiFillLeftCircle className={styles.circl} />
          </div>
          <AddScore />
          <EditScore />
          <FilterScore />
          <DeleteScore index={selectedItem} customers={customers} />
        </div>
      </div>
    </div>
  );
};

export default Score;
